/** 农事作业总览路径 */
export const FIELD_WORK_OVERVIEW_PATH = '/production/field-work';

/** 总览 Tab：专项作业入口 */
export const FIELD_WORK_ENTRIES_TAB = 'entries';

/** 从专项二级页返回总览「专项作业入口」Tab */
export const fieldWorkEntriesUrl = (extraParams = {}) => {
  const q = new URLSearchParams();
  q.set('tab', FIELD_WORK_ENTRIES_TAB);
  Object.entries(extraParams).forEach(([k, v]) => {
    if (v != null && String(v).trim() !== '') q.set(k, String(v).trim());
  });
  return `${FIELD_WORK_OVERVIEW_PATH}?${q.toString()}`;
};

/** 面包屑：总览下专项入口子路由 */
export const FIELD_WORK_ENTRY_CHILD_SEGMENTS = new Set([
  'sowing',
  'fertilizing',
  'machinery',
  'irrigation',
  'weeding',
  'pest-control',
  'ledger'
]);

export const isFieldWorkEntryChildPath = (pathname) => {
  const parts = String(pathname || '').split('/').filter(Boolean);
  const idx = parts.indexOf('field-work');
  if (idx < 0 || idx >= parts.length - 1) return false;
  return FIELD_WORK_ENTRY_CHILD_SEGMENTS.has(parts[idx + 1]);
};
